import { Component, Input, OnInit, Output } from '@angular/core';

import { EventEmitter } from "@angular/core";
import { DataService } from "../../../data.service";
import {QueryBuilder, QueryService} from '../../../@tools/query';
import { CONFIG } from '../../../config';


@Component({
    selector: 'app-relation',
    templateUrl: './relation.component.html',
    styleUrls: ['./relation.component.scss']
})
export class RelationComponent implements OnInit {

    @Input() table: string;
    @Input() where: string[];
    @Output() onChangeId: EventEmitter<any> = new EventEmitter();
    @Output() onClose: EventEmitter<any> = new EventEmitter();

    types;
    fields;
    model;
    data;
    pages;
    current;

    find_model: { [k: string]: any } = {};

    pattern = {
        string: '^.{0,255}$',
        text: '^.*$',
        integer: '^[0-9]*$',
        float: '^([0-9]+\\.)?[0-9]*$',
    };

    url = CONFIG.url;


    constructor(private query: QueryService, private DATA: DataService) {
    }

    ngOnInit() {
        this.query.types(this.table).subscribe(response => {
            this.types = response;
        });
        this.query.fields(this.table).subscribe(response => {
            this.fields = response;
        });
        this.query.model(this.table).subscribe(response => {
            this.model = response;
        });
        let qb = new QueryBuilder(this.table);
        if (this.where) {
            qb.where(this.where[0], this.where[1], this.where[2]);
        }
        this.DATA.applyWith(this.table, qb);

        this.query.get(qb).then(response => {
            this.data = response['data'];
            this.DATA.applyModels(this.table, this.data);
            this.pages = response['last_page'];
            this.current = response['current_page'];
        });
    }

    search() {
        this.current = 1;
        let keys = Object.keys(this.find_model);

        let qb = new QueryBuilder(this.table);
        for (let i in keys) {
            qb.where(keys[i], 'like', '%' + this.find_model[keys[i]] + '%');
        }
        this.DATA.applyWith(this.table, qb);
        qb.page(this.current);

        this.query.get(qb).then(response => {
            this.data = response['data'];
            this.DATA.applyModels(this.table, this.data);
            this.pages = response['last_page'];
            this.current = response['current_page'];
        });
    }

    send(id) {
        this.onChangeId.emit({ id: id });
    }

    close() {
        this.onClose.emit();
    }

    changed(page) {
        this.current = page;
        this.search();
    }
}
